import type {SavedView, SavedViewVisibility} from './types'

export const DEFAULT_VIEW_VISIBILITY: SavedViewVisibility = 'team'

export function viewVisibility(view: SavedView): SavedViewVisibility {
  return view.visibility ?? DEFAULT_VIEW_VISIBILITY
}

export function splitViewsByVisibility(views: readonly SavedView[]): {
  team: SavedView[]
  personal: SavedView[]
} {
  const team: SavedView[] = []
  const personal: SavedView[] = []

  for (const view of views) {
    if (viewVisibility(view) === 'personal') {
      personal.push(view)
    } else {
      team.push(view)
    }
  }

  return {team, personal}
}
